import React from "react";
import useAnimatedCount from "../../../hooks/useAnimatedCount";

/**
 * Component that displays a number with a smooth spring animation when the value changes
 * @param {number} value - The target value to animate to
 * @param {object} springOptions - Optional spring configuration (stiffness, damping, mass)
 * @param {object} props - Additional props to pass to the span element
 * @returns {JSX.Element} - A span element displaying the animated value
 */
const AnimatedCount = ({ value, springOptions, ...props }) => {
  const displayValue = useAnimatedCount(value, springOptions);

  return <span {...props}>{displayValue.toLocaleString()}</span>;
};

export default AnimatedCount;
